
import React, { useEffect, useRef } from 'react';
import { Password } from 'primereact/password';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';

const SharedPasswordField = ({
  placeholder = '',
  label = '',
  name = '',
  className = '',
  isIcon = false,
  icon,
  iconPos = 'left',
  iconClassName = '',
  defaultValue = '',
  type = 'password',
  parentClass = '',
  ...props
}) => {
  const [field, meta] = useField(name);
  const passwordRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    // Fix RTL password icon position
    const fixRTLIcon = () => {
      const dir = document.documentElement.getAttribute('dir');
      if (dir === 'rtl') {
        setTimeout(() => {
          const icons = document.querySelectorAll('.p-password-show-icon, .p-password-hide-icon');
          icons.forEach(icon => {
            if (icon.parentElement) {
              icon.parentElement.style.left = '0px';
              icon.parentElement.style.right = 'auto';
            }
          });
        }, 100);
      }
    };

    fixRTLIcon();
    const observer = new MutationObserver(fixRTLIcon);
    if (passwordRef.current) {
      observer.observe(passwordRef.current, {
        childList: true,
        subtree: true,
        attributes: true
      });
    }

    return () => observer.disconnect();
  }, []);


  return (
    <div className={`flex flex-col gap-1 w-full mb-1 ${parentClass}`} ref={passwordRef}>
      <label htmlFor={name} className='input-label'>
        {label}
      </label>
      <div className='relative'>
        <Password
          id={name}
          placeholder={placeholder}
          type={type}
          {...field}
          {...props}
          className={`relative input-field ${className} ${isIcon && iconPos === 'left' ? '!pl-10' : iconPos === 'right' ? '!pr-10' : null
            } `}
          pt={{
            root: { className: `border border-gray-300 !w-full !h-full !p-0 !py-0 !pe-0 ${icon ? '' : '!ps-2 !pl-0'}` },
            iconField: { root: { className: 'w-full' } },
            input: {
              className:
                '!p-[0.6rem] !w-[90%] !h-full !border-0 focus:outline-none !bg-gray-100 focus:shadow-none focus:bg-gray-100 !pl-[0]'
            },
            panel: { className: 'hidden' },
            showIcon: {
              className: 'top-2 [dir="rtl"]_&:!right-auto [dir="rtl"]_&:!left-[0] !right-[0]',
              style: document.documentElement.getAttribute('dir') === 'rtl' ? { right: 'auto', left: '0' } : {}
            },
            hideIcon: {
              className: 'top-2 [dir="rtl"]_&:!right-auto [dir="rtl"]_&:!left-[0] !right-[0]',
              style: document.documentElement.getAttribute('dir') === 'rtl' ? { right: 'auto', left: '0' } : {}
            }
          }}
        />
        {isIcon && (
          <div
            className={`absolute top-1/2 transform -translate-y-1/2 ${iconPos === 'left' ? 'left-3' : 'left-auto right-3'
              } text-iconC ${iconClassName}`}
          >
            {icon}
          </div>
        )}
      </div>
      {meta.error && meta.touched && <p className='text-sm text-red-500'>{t(meta.error)}</p>}
    </div>
  );
};

export default SharedPasswordField;
